var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHfaBarLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 266.173 171.578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lines"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Border",
    x: 0.59375,
    y: 0.578125,
    width: 264.984,
    height: 170,
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M0 171.078H266.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M0 128.434H266.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    d: "M0 85.7891H266.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    d: "M0 43.1445H266.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 6",
    d: "M0 0.5H266.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfaBarLines);
export default __webpack_public_path__ + "static/media/hfa_bar_lines.1f301c061eab2b619f561afc1d355743.svg";
export { ForwardRef as ReactComponent };